import HomePage from "HomePage";
import React, { useContext, useEffect, useState } from "react";
import LoginPage from "LoginPage";
import "App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ErrorPage from "routes/ErrorRoute";
import OAuthCallback from "routes/OAuthCallback";
import PrivateRoute from "routes/PrivateRoute";
import { IsAuthenticatedContext } from "context/IsAuthenticatedContext";
import MobileView from "components/MobileView/MobileView";
import { YourGeneratedPodcastProvider } from "context/LibraryYourGeneratedPodcastContext";
import { CurrentlyPlayingContextProvider } from "context/CurrentlyPlayingContext";
import { UserInfoContextProvider } from "context/UserInfoContext";

const isMobileDevice = () => {
  return /Mobi|Android/i.test(navigator.userAgent);
};

const App = () => {
  const { isAuthenticated, setIsAuthenticated } = useContext(
    IsAuthenticatedContext
  );
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(isMobileDevice());
    const token = localStorage.getItem("access_token");
    setIsAuthenticated(!!token); // Set to true if token exists, otherwise false
  }, []);

  return (
    <Router>
      <Routes>
        {/* Can only listen in mobile view  */}
        {isMobile ? (
          <Route
            path="*"
            element={
              isAuthenticated ? (
                <YourGeneratedPodcastProvider>
                  <CurrentlyPlayingContextProvider>
                    <UserInfoContextProvider>
                      <MobileView />
                    </UserInfoContextProvider>
                  </CurrentlyPlayingContextProvider>
                </YourGeneratedPodcastProvider>
              ) : (
                <LoginPage />
              )
            }
          />
        ) : (
          <>
            <Route
              path="/login"
              element={
                isAuthenticated ? <Navigate to="/home" /> : <LoginPage />
              }
            />
            <Route path="/oauth/callback" element={<OAuthCallback />} />
            {/* Protect the HomePage route */}
            <Route
              path="/home"
              element={<PrivateRoute element={<HomePage />} />}
            />
            {/* Set root to login page */}
            <Route path="/" element={<Navigate to="/login" />} />
            <Route path="*" element={<ErrorPage />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default App;
